export const BBCORDERDEATIL_FILE = 'BBCORDERDEATIL_FILE';
// 更新
export const BBC_NO_DELIVERY_AREA_UDATE = 'BBC_NO_DELIVERY_AREA_UDATE';
